import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureService } from 'src/app/core/firebase/feature.service';
import { FreePlayLobbyService } from 'src/app/core/firebase/free-play.service';
import { SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';

@Component({
    selector: 'app-purchase-confirmation',
    templateUrl: './purchase-confirmation.component.html',
    styleUrls: ['./purchase-confirmation.component.scss'],
    standalone: false
})
export class PurchaseConfirmationComponent implements OnInit {


    constructor(
        private sopoDialogRef: SopoDialogRef,
        private freeplayService: FreePlayLobbyService,
        private router: Router,
    ) { }

    ngOnInit() { }

    close() {
        this.sopoDialogRef.close();
    }

    doNotShowSweeps() {
        localStorage.setItem('doNotShowPurchaseConfirmation','true');
        this.close();
    }

    goToAnotherPage(url: 'freeplay' | 'sweepstakes') {
        this.close();
        const noTransition =  this.router.url.includes('lobby/home/sweepstakes') ? true : false;
        // TEMP LATER
        //this.freeplayService.navigateToSelectedPlay(url, noTransition);
    }

}
